import type { Country } from '@tectonics/prs/country';
import type { CountrySchema } from './types';

export const createCountrySchemaRegistry = (
  countrySchemas: readonly CountrySchema[],
): Map<Country, CountrySchema> => {
  if (new Set(countrySchemas.map(({ country }) => country)).size !== countrySchemas.length) {
    throw new Error('Duplicate country schemas found');
  }

  return new Map(countrySchemas.map(schema => [schema.country, schema]));
};
